import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
	About,
	Contact,
	Home,
	Navigation
} from "./components";
import logo from './logo.svg';
import './App.css';

function App() {
	return (
		<div className="App">
			<Router>
				<Switch>
					<Route path="/" exact component={() => <Home />} />
					<Route path="/profile" exact component={() => <About />} />
					<Route path="/contact" exact component={() => <Contact />} />
				</Switch>
			</Router>
		</div>
	);
}

export default App;
